module.exports = __webpack_public_path__ + "img/Central-African-Repu.2f27ae50.png";